import React, { useContext, useEffect, useState } from 'react'
import Icons from '../../components/Icons'
import CreateNewGallery from './CreateNewGallery'
import Layout from './LayoutGallery'; 
import { Context } from "../contexts/AppContext";
import GalleryThumbnail from './GalleryThumbnail';
import Uploadvideo from './UploadVideo';
import GalleryHeader from './GalleryHeader';

function GalleryManager({selectedFolder}) {    
 
    const [videoUploadPage, setVideoUploadPage] = useState(false)
    const [showLayout,setShowLayout]=useState(false)
    const { value } = useContext(Context);
    const [appState, setAppState] = value;
    const [newGalleryBtnClicked,setNewGalleryBtnClicked]=useState(false)
    const [galleryThumbnailPage,setGalleryThumbNailPage]=useState(true)

     
     
 
    useEffect(()=>{
     
setShowLayout(false)
    },[])
  
     

    useEffect(()=>{
      
      if(appState.currentGalleryName)
      {
        setShowLayout(false)
        setVideoUploadPage(true)
      }
      
    },[appState?.currentGalleryName])
 

  
    const layoutSelected=()=>{
      setAppState((prevState) => ({ ...prevState,
        modalData:{ ...prevState.modalData, type: "NewGalleryModal", isOpen: true, galeryUpdate:true}}
      ));
    }
    
    
    const closeCreateNewGalleryPage=()=>{

      console.log("CCCCCCCCCCCCLOSE--------");
 
      setAppState((prevState) => ({ ...prevState,
        modalData:{ ...prevState.modalData, type: "NewTemplateModal", isOpen: true}}
      ));


     

      
    }
  return (
   <div className='h-[100vh]'>  

 
  <GalleryHeader/>
    {appState?.currentFolderData?.galleries.length<=0?<div className='flex flex-col justify-center border h-[calc(100vh-140px)] items-center'>
      <div className='p-4'><b>No Album added yet</b></div>
      <CreateNewGallery closeCreateNewGalleryPage={closeCreateNewGalleryPage}/></div>:null}
    {showLayout && <Layout layoutSelected={layoutSelected} />}
     {appState?.currentFolderData?.galleries.length>0 && galleryThumbnailPage? <GalleryThumbnail />:null}  
     {/* {videoUploadPage && <Uploadvideo  />} */}
    
   </div>

  )
}

export default GalleryManager